import { createSelector } from '@reduxjs/toolkit';
// import { call, all, put, takeEvery } from 'redux-saga/effects';
import { createApi } from '@reduxjs/toolkit/query/react';
import { Item } from './models';
import { baseApi } from '@centerpiece/components';
import { project } from './project.api';

export const item = baseApi
  .enhanceEndpoints({ addTagTypes: ['Items', 'Item'] })
  .injectEndpoints({
    endpoints: builder => ({
      getItems: builder.query<Item[], { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: 'item',
          method: 'GET',
          params: params ? params : { nested: 'all' },
        }),
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: 'Item' as const, id })),
                'Items',
              ]
            : ['Items'],
      }),
      getItem: builder.query<Item, { id: number; params?: object }>({
        query: ({ id, params }: { id: number; params?: object }) => ({
          url: `item/${id}`,
          method: 'GET',
          params: params ? { nested: 'all', ...params } : { nested: 'all' },
        }),
        providesTags: (result, error, arg) => [{ type: 'Item', id: arg.id }],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 5,
        transformResponse(data: Item, meta, arg) {
          return {
            ...data?.task_r,
            ...data,
            // title: data?.task_r?.title,
            // status: data?.task_r?.status,
            // status_r: { ...data?.task_r?.status_r },
          };
        },
      }),
      createItem: builder.mutation({
        query: request => ({
          url: 'item',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => {
          project.util.invalidateTags([
            'Projects',
            { type: 'Project', id: arg.project },
          ]);
          return ['Items'];
        },
      }),
      patchItem: builder.mutation<Item, Item>({
        query: request => ({
          url: `item/${request.id}`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => {
          return ['Items', { type: 'Item', id: arg.id }];
        },
        // async onQueryStarted({ id, sequence = 0, project: pid, ...patch }, { dispatch, queryFulfilled }) {
        //   const patchResults = dispatch(
        //     project.util.updateQueryData('getProject', { id: pid, params: { optimized: true } }, (draftProject) => {
        //       //Find task and update
        //       const newProject = {
        //         ...draftProject,
        //         items: [...draftProject?.items?.map(item => {
        //           if (item.id === id) {
        //             return ({
        //               ...item,
        //               ...patch,
        //               sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //             })
        //           } else {
        //             return ({
        //               ...item,
        //               sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //             })
        //           }
        //         })],
        //         groupings: [...draftProject?.groupings?.map(grouping => ({
        //           ...grouping,
        //           items: [...grouping?.items?.map(item => {
        //             if (item.id === id) {
        //               return ({
        //                 ...item,
        //                 ...patch,
        //                 sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //               })
        //             } else {
        //               return ({
        //                 ...item,
        //                 sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //               })
        //             }
        //           })]
        //         }))]
        //       }
        //       Object.assign(draftProject, newProject)
        //     })
        //   )
        //   try {
        //     await queryFulfilled;
        //   } catch {
        //     patchResults.undo()
        //     /**
        //      * Alternatively, on failure you can invalidate the corresponding cache tags
        //      * to trigger a re-fetch:
        //      * dispatch(task.util.invalidateTags(['Tasks']))
        //      */
        //     dispatch(project.util.invalidateTags([{ type: 'Project', id: pid }]))
        //   }
        // },
      }),
      updateItem: builder.mutation<Item, Item>({
        query: request => ({
          url: `item/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => {
          return ['Items', { type: 'Item', id: arg.id }];
        },
        // async onQueryStarted({ id, sequence = 0, project: pid, ...patch }, { dispatch, queryFulfilled }) {
        //   const patchResults = dispatch(
        //     project.util.updateQueryData('getProject', { id: pid, params: { optimized: true } }, (draftProject) => {
        //       //Find task and update
        //       const newProject = {
        //         ...draftProject,
        //         items: [...draftProject?.items?.map(item => {
        //           if (item.id === id) {
        //             return ({
        //               ...item,
        //               ...patch,
        //               sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //             })
        //           } else {
        //             return ({
        //               ...item,
        //               sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //             })
        //           }
        //         })],
        //         groupings: [...draftProject?.groupings?.map(grouping => ({
        //           ...grouping,
        //           items: [...grouping?.items?.map(item => {
        //             if (item.id === id) {
        //               return ({
        //                 ...item,
        //                 ...patch,
        //                 sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //               })
        //             } else {
        //               return ({
        //                 ...item,
        //                 sequence: item.sequence > sequence ? item.sequence + 1 : item.sequence,
        //               })
        //             }
        //           })]
        //         }))]
        //       }
        //       Object.assign(draftProject, newProject)
        //     })
        //   )
        //   try {
        //     await queryFulfilled;
        //   } catch {
        //     patchResults.undo()
        //     /**
        //      * Alternatively, on failure you can invalidate the corresponding cache tags
        //      * to trigger a re-fetch:
        //      * dispatch(task.util.invalidateTags(['Tasks']))
        //      */
        //     dispatch(project.util.invalidateTags([{ type: 'Project', id: pid }]))
        //   }
        // },
      }),
      deleteItem: builder.mutation<Item, number>({
        query: id => ({
          url: `item/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result ? [{ type: 'Item' as const, arg }, 'Items'] : ['Items'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  usePatchItemMutation,
  useGetItemsQuery,
  useGetItemQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
  useLazyGetItemsQuery,
  usePrefetch: useItemsPrefetch,
} = item;
const selectItemsRoot = item.endpoints.getItems.select({});
export const selectItems = createSelector(
  selectItemsRoot,
  item => item.data || []
);

export const subscribeItem = item.endpoints.getItem.useQueryState;
